export default __webpack_public_path__ + "static/bitdefender_logo-a903dd02a2a48387b42182166a947f9e.png";